var map = {
	"./charts/charts.module": [
		"./src/app/charts/charts.module.ts",
		"default~charts-charts-module~dashboard-dashboard-module~pages-full-pages-full-pages-module",
		"common",
		"charts-charts-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"default~charts-charts-module~dashboard-dashboard-module~pages-full-pages-full-pages-module",
		"default~dashboard-dashboard-module~pages-full-pages-full-pages-module",
		"common",
		"dashboard-dashboard-module"
	],
	"./forms/forms.module": [
		"./src/app/forms/forms.module.ts",
		"common",
		"forms-forms-module"
	],
	"./pages/content-pages/content-pages.module": [
		"./src/app/pages/content-pages/content-pages.module.ts",
		"pages-content-pages-content-pages-module"
	],
	"./pages/full-pages/full-pages.module": [
		"./src/app/pages/full-pages/full-pages.module.ts",
		"default~charts-charts-module~dashboard-dashboard-module~pages-full-pages-full-pages-module",
		"default~dashboard-dashboard-module~pages-full-pages-full-pages-module",
		"common",
		"pages-full-pages-full-pages-module"
	],
	"./tables/tables.module": [
		"./src/app/tables/tables.module.ts",
		"common",
		"tables-tables-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;